import { autoinject } from "aurelia-framework";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";
import { CreateRequestForQuote, QuoteLinesModel } from "../../models/quote.models";

@autoinject
export class QuoteService {

    public quoteBaseUrl: string = `${this.configService.config.urls.rightStoreApiUrl}/api/Quote`;

    constructor(private configService: ConfigService, private requestClientService: RequestClientService) { }

    //get all quotelines
    public async getQuote(request: CreateRequestForQuote): Promise<QuoteLinesModel> {        
        return await this.requestClientService.post<QuoteLinesModel>(`${this.quoteBaseUrl}/CreateRequestForQuote`, {}, request);      
    }
}